import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { Button, Form, Alert } from 'react-bootstrap';

const DeviceRegister = () => {
  const [deviceName, setDeviceName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [configure, setConfigure] = useState(false);
  const [deviceId, setDeviceId] = useState('');
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate('/app');
    }
  }, [token, navigate]);

  useEffect(() => {
    if (configure) {
      navigate(`/app/devices/edit/${deviceId}`, {
        state: {
          board: {},
          sensors: [],
          actionPins: [],
          automations: [],
          deviceName,
        },
      });
    }
  }, [configure, deviceId, navigate, deviceName]);

  const handleRegisterDevice = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || ''}/api/devices/register`,
        { deviceName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDeviceId(response.data.deviceId);
      setSuccess('Device registered successfully!');
      setError('');
      setConfigure(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Device registration failed');
      setSuccess('');
    }
  };

  return (
    <div className="app-surface-card p-4" style={{ maxWidth: 520 }}>
      <h2 className="main mb-4" style={{ fontFamily: 'var(--font-display)', fontSize: '1.25rem' }}>
        Register Device
      </h2>
      <Form onSubmit={handleRegisterDevice}>
        <Form.Group className="mb-3" controlId="deviceName">
          <Form.Label>Device Name</Form.Label>
          <Form.Control
            type="text"
            value={deviceName}
            onChange={(e) => setDeviceName(e.target.value)}
            placeholder="e.g. Strawberry Patch"
            required
          />
        </Form.Group>
        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}
        <div className="d-flex gap-2">
          <Button variant="secondary" type="submit">
            Register & Configure
          </Button>
          <Button variant="outline-secondary" onClick={() => navigate('/app/dashboard')}>
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default DeviceRegister;